// Role definitions
export const ROLES = {
  SUPER_ADMIN: "0",
  ADMIN: "admin",
  BROKER: "2",
};

// Menu configuration with role access
export const MENU_CONFIG = {
  dashboard: {
    path: "/admin/dashboard",
    icon: "bx bx-home-circle",
    label: "Dashboard",
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BROKER],
  },
  userManagement: {
    title: "User Management",
    items: {
      users: {
        path: "/admin/users",
        icon: "bx bxs-user",
        label: "Users",
        roles: [ROLES.ADMIN],
      },
      agents: {
        path: "/admin/agents",
        icon: "fas fa-user-tie",
        label: "Agents",
        roles: [ROLES.ADMIN, ROLES.BROKER],
      },
      brokers: {
        path: "/admin/brokers",
        icon: "fas fa-users",
        label: "Brokers",
        roles: [ROLES.ADMIN],
      },
      
     
    },
  },
  bms: {
    title: "BMS",
    items: {
      propertyInventory: {
        path: "/admin/property",
        icon: "fas fa-laptop-house",
        label: "Properties",
        roles: [ROLES.ADMIN, ROLES.BROKER],
      },
      subscriptionPackages: {
        path: "/admin/subscription-packages",
        icon: "bx bx-package",
        label: "Subscription Packages",
        roles: [ROLES.ADMIN],
      },
      paymentFailures: {
        path: "/admin/payment-failures",
        icon: "bx bx-error-circle",
        label: "Payment Failures",
        roles: [ROLES.ADMIN],
      },
      propertyFeatures: {
        path: "/admin/property-features",
        icon: "bx bx-list-ul",
        label: "Property Features",
        roles: [ROLES.ADMIN],
      },
      
    },
  },
  // revenue: {
  //   title: "Revenue",
  //   items: {
  //     revenueModule: {
  //       path: "/admin/revenue",
  //       icon: "bx bx-line-chart",
  //       label: "Revenue Module",
  //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  //     },
  //     providers: {
  //       path: "/admin/providers",
  //       icon: "bx bx-id-card",
  //       label: "Providers",
  //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  //     },
  //   },
  // },
  // contact: {
  //   title: "Contact",
  //   items: {
  //     contactUs: {
  //       path: "/admin/contact",
  //       icon: "bx bx-headphone",
  //       label: "Contact Us",
  //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  //     },
  //   },
  // },
  // settings: {
  //   title: "Settings",
  //   items: {
  //     propertyAttributes: {
  //       path: "/admin/property-dropdown-options",
  //       icon: "bx bx-list-ol",
  //       label: "Property Attributes",
  //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  //     },
  //     roomsAttributes: {
  //       path: "/admin/rooms-dropdown-options",
  //       icon: "bx bx-list-ol",
  //       label: "Rooms Attributes",
  //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  //     },
  //     amenities: {
  //       path: "/admin/amenities",
  //       icon: "bx bx-list-ol",
  //       label: "Amenities",
  //       roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  //     },
  //   },
  // },
};

export const getCurrentUserRole = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    console.log(authUser?.data?.role, "authUser role");
    return authUser?.data?.role?.toString() ?? "2";
  } catch (error) {
    console.error("Error getting user role:", error);
    return "2";
  }
};

export const getCurrentUser = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    return authUser;
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
};

export const getCurrentUserId = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    return authUser?.data?._id || authUser?.data?.id || null;
  } catch (error) {
    console.error("Error getting user ID:", error);
    return null;
  }
};

export const getCurrentBrokerOfficeId = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    return authUser?.data?.myRealStateOffice?._id || null;
  } catch (error) {
    console.error("Error getting broker office ID:", error);
    return null;
  }
};

export const hasAccess = (menuItem, userRole) => {
  // Super admin always has access
  if (userRole === ROLES.SUPER_ADMIN) return true;
  
  // If no roles specified, allow access
  if (!menuItem.roles) return true;
  
  // Check if user role is in allowed roles
  return menuItem.roles.includes(userRole);
}; 